import { initializeAndTrack } from 'gatsby-plugin-gdpr-cookies'
import { TFunction } from 'i18next'

import { COOKIE_DOMAIN } from '@core/Constants/CookieConstants'
import { CookiesState } from '@icontainers/design-system/dist/molecules/AcceptCookiesModal'
import { startTracking } from '@infrastructure/Mixpanel'
import { initializeSourceBuster } from '@infrastructure/SourceBuster'
import { WindowLocation } from '@reach/router'
import { initializeClarity } from '@src/Infrastructure/Clarity'
import { setGdprCookie } from '@src/Infrastructure/Cookies'
import { sendCookiePermissionUpdateGa4Event } from '@src/Infrastructure/GoogleTagManager/GA4Events/CookiePermission'

export const onAccept =
    ({
        setAccepted,
        location,
        sendVirtualPageViewGa4Event,
        setSendMixpanelEvents,
    }: {
        setAccepted: (accepted: boolean) => void
        location: WindowLocation<unknown>
        sendVirtualPageViewGa4Event: () => void
        setSendMixpanelEvents: (sendMixpanelEvents: boolean) => void
    }) =>
    (cookiesState: CookiesState): void => {
        setAccepted(true)
        setGdprCookie(cookiesState)
        initializeAndTrack(location)
        sendVirtualPageViewGa4Event()
        const analyticsStorage = cookiesState.performance ? 'granted' : 'denied'
        const adStorage = cookiesState.marketing ? 'granted' : 'denied'
        sendCookiePermissionUpdateGa4Event(analyticsStorage, adStorage)
        initializeSourceBuster(COOKIE_DOMAIN.replace(/^\./, ''))
        startTracking()
        setSendMixpanelEvents(true)
        initializeClarity()
    }

type InfoType = { title: string; description: string }
type GetCookieIno = (t: TFunction) => { necessary: InfoType; performance: InfoType; marketing: InfoType }
export const getCookieInfo: GetCookieIno = (t) => {
    return {
        necessary: {
            title: t('necessaryCookieTitle'),
            description: t('necessaryCookieDescription'),
        },
        performance: {
            title: t('performanceCookieTitle'),
            description: t('performanceCookieDescription'),
        },
        marketing: {
            title: t('marketingCookieTitle'),
            description: t('marketingCookieDescription'),
        },
    }
}
